export default __webpack_public_path__ + "static/card_img-3-0266de6a78ad39b4bdd8f1da1dee1a47.jpg";